import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const CATEGORIES = [
  {
    name: "Rações para Cães & Gatos",
    tag: "Nutrição",
    description: "Alta performance para filhotes e adultos, das marcas que você confia.",
    image:
      "https://images.unsplash.com/photo-1759801345063-2645087e9fcf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w5Nzg4N3wwfDF8c2VhcmNofDF8fHBldCUyMGZvb2QlMjBydXN0aWMlMjBib3dsfGVufDB8fHx8MTc5MTIyMzI0N3ww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
  },
  {
    name: "Petshop & Acessórios",
    tag: "Cuidado",
    description: "Coleiras, brinquedos, camas, higiene e petiscos.",
    image:
      "https://images.unsplash.com/photo-1597595735781-6a57fb8e3e3d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxkb2clMjBncm9vbWluZyUyMGJhdGglMjBwZXQlMjBjYXJlfGVufDB8fHx8MTc5MTIyMzI1OHww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5",
  },
  {
    name: "Campo & Pecuária",
    tag: "Criação",
    description: "Sal mineral, suplementos, selaria e artigos para a fazenda.",
    image:
      "https://images.unsplash.com/photo-1620123357390-86c161acbb7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxjb3dzJTIwaW4lMjBncmVlbiUyMHBhc3R1cmUlMjBmaWVsZHxlbnwwfHx8fDE3OTEyMjMyNTh8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-5",
  },
  {
    name: "Jardim & Ferramentas Agro",
    tag: "Plantio",
    description: "Sementes, adubos, ferramentas e pulverizadores.",
    image:
      "https://images.unsplash.com/photo-1778870810150-0de5220f32e3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwxfHxmYXJtJTIwZ2FyZGVuJTIwdG9vbHMlMjBydXJhbHxlbnwwfHx8fDE3OTEyMjMyNDd8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-7",
  },
];

export default function Categories() {
  return (
    <section id="categorias" data-testid="categories-section" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14 max-w-2xl"
        >
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-clay">
            O que você encontra
          </p>
          <h2 className="font-display text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
            Da porteira pra dentro, <em className="not-italic text-olive">a gente resolve.</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
          {CATEGORIES.map((cat, i) => (
            <motion.a
              key={cat.name}
              href="#catalogo"
              data-testid={`category-card-${i}`}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className={`group relative h-80 overflow-hidden rounded-[2rem] ${cat.span} ${
                i % 2 === 0 ? "md:rounded-tr-[4rem]" : "md:rounded-bl-[4rem]"
              }`}
            >
              <img
                src={cat.image}
                alt={cat.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/30 to-transparent" />
              <span className="absolute left-6 top-6 rounded-full border border-parchment/30 bg-parchment/15 px-3 py-1 font-mono text-[10px] font-medium uppercase tracking-[0.2em] text-parchment backdrop-blur">
                {cat.tag}
              </span>
              <div className="absolute inset-x-6 bottom-6 flex items-end justify-between gap-4">
                <div>
                  <h3 className="font-display text-2xl font-medium text-parchment sm:text-3xl">{cat.name}</h3>
                  <p className="mt-2 max-w-sm text-sm text-parchment/75">{cat.description}</p>
                </div>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-clay text-parchment transition-transform duration-300 group-hover:rotate-45">
                  <ArrowUpRight className="h-5 w-5" />
                </span>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
